module.exports = __webpack_public_path__ + "img/krypton.f0d253f2.png";